

import unkwnown from './logos/default.png';
import logo0B from './logos-small/0B.png';
const logo0E = unkwnown;
const logo0Q = unkwnown;
const logo0V = unkwnown;
const logo01 = unkwnown;
import logo1A from './logos-small/1A.png';
import logo1B from './logos-small/1B.png';
import logo1C from './logos-small/1C.png';
import logo1D from './logos-small/1D.png';
import logo1E from './logos-small/1E.png';
import logo1F from './logos-small/1F.png';
import logo1G from './logos-small/1G.png';
import logo1H from './logos-small/1H.png';
import logo1I from './logos-small/1I.png';
import logo1J from './logos-small/1J.png';
import logo1K from './logos-small/1K.png';
import logo1L from './logos-small/1L.png';
import logo1M from './logos-small/1M.png';
import logo1N from './logos-small/1N.png';
import logo1P from './logos-small/1P.png';
import logo1Q from './logos-small/1Q.png';
import logo1R from './logos-small/1R.png';
import logo1S from './logos-small/1S.png';
import logo1T from './logos-small/1T.png';
import logo1U from './logos-small/1U.png';
import logo1X from './logos-small/1X.png';
import logo1Y from './logos-small/1Y.png';
import logo1Z from './logos-small/1Z.png';
const logo02 = unkwnown;
import logo2A from './logos-small/2A.png';
import logo2B from './logos-small/2B.png';
import logo2C from './logos-small/2C.png';
import logo2D from './logos-small/2D.png';
import logo2E from './logos-small/2E.png';
import logo2F from './logos-small/2F.png';
import logo2G from './logos-small/2G.png';
import logo2H from './logos-small/2H.png';
import logo2I from './logos-small/2I.png';
import logo2J from './logos-small/2J.png';
import logo2K from './logos-small/2K.png';
import logo2L from './logos-small/2L.png';
import logo2M from './logos-small/2M.png';
import logo2N from './logos-small/2N.png';
import logo2O from './logos-small/2O.png';
import logo2P from './logos-small/2P.png';
import logo2Q from './logos-small/2Q.png';
import logo2R from './logos-small/2R.png';
import logo2S from './logos-small/2S.png';
import logo2T from './logos-small/2T.png';
import logo2U from './logos-small/2U.png';
import logo2V from './logos-small/2V.png';
import logo2W from './logos-small/2W.png';
import logo2Y from './logos-small/2Y.png';
import logo2Z from './logos-small/2Z.png';
import logo3A from './logos-small/3A.png';
import logo3B from './logos-small/3B.png';
import logo3C from './logos-small/3C.png';
import logo3D from './logos-small/3D.png';
import logo3E from './logos-small/3E.png';
import logo3F from './logos-small/3F.png';
import logo3G from './logos-small/3G.png';
import logo3H from './logos-small/3H.png';
import logo3I from './logos-small/3I.png';
import logo3J from './logos-small/3J.png';
import logo3K from './logos-small/3K.png';
import logo3L from './logos-small/3L.png';
import logo3M from './logos-small/3M.png';
import logo3N from './logos-small/3N.png';
import logo3O from './logos-small/3O.png';
import logo3P from './logos-small/3P.png';
import logo3Q from './logos-small/3Q.png';
import logo3R from './logos-small/3R.png';
import logo3S from './logos-small/3S.png';
import logo3T from './logos-small/3T.png';
import logo3U from './logos-small/3U.png';
import logo3V from './logos-small/3V.png';
import logo3W from './logos-small/3W.png';
import logo3X from './logos-small/3X.png';
import logo3Y from './logos-small/3Y.png';
import logo3Z from './logos-small/3Z.png';
const logo04 = unkwnown;
import logo4A from './logos-small/4A.png';
import logo4B from './logos-small/4B.png';
import logo4C from './logos-small/4C.png';
import logo4D from './logos-small/4D.png';
import logo4E from './logos-small/4E.png';
import logo4G from './logos-small/4G.png';
import logo4H from './logos-small/4H.png';
import logo4I from './logos-small/4I.png';
import logo4J from './logos-small/4J.png';
import logo4K from './logos-small/4K.png';
import logo4L from './logos-small/4L.png';
import logo4M from './logos-small/4M.png';
import logo4N from './logos-small/4N.png';
import logo4O from './logos-small/4O.png';
import logo4P from './logos-small/4P.png';
import logo4Q from './logos-small/4Q.png';
import logo4R from './logos-small/4R.png';
import logo4T from './logos-small/4T.png';
import logo4U from './logos-small/4U.png';
import logo4V from './logos-small/4V.png';
import logo4W from './logos-small/4W.png';
import logo4X from './logos-small/4X.png';
import logo4Y from './logos-small/4Y.png';
import logo4Z from './logos-small/4Z.png';
import logo5A from './logos-small/5A.png';
import logo5B from './logos-small/5B.png';
import logo5C from './logos-small/5C.png';
import logo5D from './logos-small/5D.png';
import logo5E from './logos-small/5E.png';
import logo5F from './logos-small/5F.png';
import logo5G from './logos-small/5G.png';
import logo5H from './logos-small/5H.png';
import logo5I from './logos-small/5I.png';
import logo5J from './logos-small/5J.png';
import logo5K from './logos-small/5K.png';
import logo5L from './logos-small/5L.png';
import logo5M from './logos-small/5M.png';
import logo5N from './logos-small/5N.png';
import logo5O from './logos-small/5O.png';
import logo5P from './logos-small/5P.png';
import logo5Q from './logos-small/5Q.png';
import logo5R from './logos-small/5R.png';
import logo5S from './logos-small/5S.png';
import logo5T from './logos-small/5T.png';
import logo5U from './logos-small/5U.png';
import logo5V from './logos-small/5V.png';
import logo5W from './logos-small/5W.png';
import logo5X from './logos-small/5X.png';
import logo5Y from './logos-small/5Y.png';
import logo5Z from './logos-small/5Z.png';
import logo6A from './logos-small/6A.png';
import logo6B from './logos-small/6B.png';
import logo6C from './logos-small/6C.png';
import logo6D from './logos-small/6D.png';
import logo6E from './logos-small/6E.png';
import logo6F from './logos-small/6F.png';
import logo6G from './logos-small/6G.png';
import logo6H from './logos-small/6H.png';
import logo6I from './logos-small/6I.png';
import logo6J from './logos-small/6J.png';
import logo6K from './logos-small/6K.png';
import logo6L from './logos-small/6L.png';
import logo6M from './logos-small/6M.png';
import logo6N from './logos-small/6N.png';
import logo6O from './logos-small/6O.png';
import logo6P from './logos-small/6P.png';
import logo6Q from './logos-small/6Q.png';
import logo6R from './logos-small/6R.png';
import logo6S from './logos-small/6S.png';
import logo6T from './logos-small/6T.png';
import logo6U from './logos-small/6U.png';
import logo6V from './logos-small/6V.png';
import logo6W from './logos-small/6W.png';
import logo6X from './logos-small/6X.png';
import logo6Y from './logos-small/6Y.png';
import logo6Z from './logos-small/6Z.png';
import logo7A from './logos-small/7A.png';
import logo7B from './logos-small/7B.png';
import logo7C from './logos-small/7C.png';
import logo7D from './logos-small/7D.png';
import logo7E from './logos-small/7E.png';
import logo7F from './logos-small/7F.png';
import logo7G from './logos-small/7G.png';
import logo7H from './logos-small/7H.png';
import logo7I from './logos-small/7I.png';
import logo7J from './logos-small/7J.png';
import logo7K from './logos-small/7K.png';
import logo7L from './logos-small/7L.png';
import logo7M from './logos-small/7M.png';
import logo7N from './logos-small/7N.png';
import logo7O from './logos-small/7O.png';
import logo7P from './logos-small/7P.png';
import logo7Q from './logos-small/7Q.png';
import logo7R from './logos-small/7R.png';
import logo7T from './logos-small/7T.png';
import logo7U from './logos-small/7U.png';
import logo7V from './logos-small/7V.png';
import logo7W from './logos-small/7W.png';
import logo7Y from './logos-small/7Y.png';
import logo7Z from './logos-small/7Z.png';
import logo8A from './logos-small/8A.png';
import logo8B from './logos-small/8B.png';
import logo8C from './logos-small/8C.png';
import logo8D from './logos-small/8D.png';
import logo8E from './logos-small/8E.png';
import logo8F from './logos-small/8F.png';
import logo8G from './logos-small/8G.png';
import logo8H from './logos-small/8H.png';
import logo8I from './logos-small/8I.png';
import logo8J from './logos-small/8J.png';
import logo8K from './logos-small/8K.png';
import logo8L from './logos-small/8L.png';
import logo8M from './logos-small/8M.png';
import logo8N from './logos-small/8N.png';
import logo8O from './logos-small/8O.png';
import logo8P from './logos-small/8P.png';
import logo8Q from './logos-small/8Q.png';
import logo8R from './logos-small/8R.png';
import logo8S from './logos-small/8S.png';
import logo8T from './logos-small/8T.png';
import logo8U from './logos-small/8U.png';
import logo8V from './logos-small/8V.png';
import logo8W from './logos-small/8W.png';
import logo8Y from './logos-small/8Y.png';
import logo8Z from './logos-small/8Z.png';
import logo9A from './logos-small/9A.png';
import logo9B from './logos-small/9B.png';
import logo9C from './logos-small/9C.png';
import logo9D from './logos-small/9D.png';
import logo9E from './logos-small/9E.png';
import logo9F from './logos-small/9F.png';
import logo9G from './logos-small/9G.png';
import logo9H from './logos-small/9H.png';
import logo9I from './logos-small/9I.png';
import logo9J from './logos-small/9J.png';
import logo9K from './logos-small/9K.png';
import logo9L from './logos-small/9L.png';
import logo9M from './logos-small/9M.png';
import logo9N from './logos-small/9N.png';
import logo9O from './logos-small/9O.png';
import logo9P from './logos-small/9P.png';
import logo9Q from './logos-small/9Q.png';
import logo9R from './logos-small/9R.png';
import logo9S from './logos-small/9S.png';
import logo9T from './logos-small/9T.png';
import logo9U from './logos-small/9U.png';
import logo9V from './logos-small/9V.png';
import logo9W from './logos-small/9W.png';
import logo9X from './logos-small/9X.png';
import logo9Y from './logos-small/9Y.png';
const logoA0 = unkwnown;
import logoA1 from './logos-small/A1.png';
import logoA2 from './logos-small/A2.png';
import logoA3 from './logos-small/A3.png';
import logoA4 from './logos-small/A4.png';
import logoA5 from './logos-small/A5.png';
import logoA6 from './logos-small/A6.png';
import logoA7 from './logos-small/A7.png';
import logoA8 from './logos-small/A8.png';
import logoA9 from './logos-small/A9.png';
import logoAA from './logos-small/AA.png';
import logoAB from './logos-small/AB.png';
import logoAC from './logos-small/AC.png';
import logoAD from './logos-small/AD.png';
import logoAE from './logos-small/AE.png';
import logoAF from './logos-small/AF.png';
import logoAG from './logos-small/AG.png';
import logoAH from './logos-small/AH.png';
import logoAI from './logos-small/AI.png';
import logoAJ from './logos-small/AJ.png';
import logoAK from './logos-small/AK.png';
import logoAL from './logos-small/AL.png';
import logoAM from './logos-small/AM.png';
import logoAN from './logos-small/AN.png';
import logoAO from './logos-small/AO.png';
import logoAP from './logos-small/AP.png';
import logoAQ from './logos-small/AQ.png';
import logoAR from './logos-small/AR.png';
import logoAS from './logos-small/AS.png';
import logoAT from './logos-small/AT.png';
import logoAU from './logos-small/AU.png';
import logoAV from './logos-small/AV.png';
import logoAW from './logos-small/AW.png';
import logoAX from './logos-small/AX.png';
import logoAY from './logos-small/AY.png';
import logoAZ from './logos-small/AZ.png';
import logoB0 from './logos-small/B0.png';
import logoB2 from './logos-small/B2.png';
import logoB3 from './logos-small/B3.png';
import logoB4 from './logos-small/B4.png';
import logoB5 from './logos-small/B5.png';
import logoB6 from './logos-small/B6.png';
import logoB7 from './logos-small/B7.png';
import logoB8 from './logos-small/B8.png';
import logoB9 from './logos-small/B9.png';
import logoBA from './logos-small/BA.png';
import logoBB from './logos-small/BB.png';
import logoBC from './logos-small/BC.png';
import logoBD from './logos-small/BD.png';
import logoBE from './logos-small/BE.png';
import logoBF from './logos-small/BF.png';
import logoBG from './logos-small/BG.png';
import logoBH from './logos-small/BH.png';
import logoBI from './logos-small/BI.png';
import logoBJ from './logos-small/BJ.png';
import logoBK from './logos-small/BK.png';
import logoBL from './logos-small/BL.png';
import logoBM from './logos-small/BM.png';
import logoBN from './logos-small/BN.png';
import logoBO from './logos-small/BO.png';
import logoBP from './logos-small/BP.png';
import logoBQ from './logos-small/BQ.png';
import logoBR from './logos-small/BR.png';
import logoBS from './logos-small/BS.png';
import logoBT from './logos-small/BT.png';
import logoBU from './logos-small/BU.png';
import logoBV from './logos-small/BV.png';
import logoBW from './logos-small/BW.png';
import logoBX from './logos-small/BX.png';
import logoBY from './logos-small/BY.png';
import logoBZ from './logos-small/BZ.png';
const logoC0 = unkwnown;
import logoC2 from './logos-small/C2.png';
import logoC3 from './logos-small/C3.png';
import logoC4 from './logos-small/C4.png';
import logoC5 from './logos-small/C5.png';
import logoC6 from './logos-small/C6.png';
import logoC7 from './logos-small/C7.png';
import logoC8 from './logos-small/C8.png';
import logoC9 from './logos-small/C9.png';
import logoCA from './logos-small/CA.png';
import logoCB from './logos-small/CB.png';
import logoCC from './logos-small/CC.png';
import logoCD from './logos-small/CD.png';
import logoCE from './logos-small/CE.png';
import logoCF from './logos-small/CF.png';
import logoCG from './logos-small/CG.png';
import logoCH from './logos-small/CH.png';
import logoCI from './logos-small/CI.png';
import logoCJ from './logos-small/CJ.png';
import logoCK from './logos-small/CK.png';
import logoCL from './logos-small/CL.png';
import logoCM from './logos-small/CM.png';
import logoCN from './logos-small/CN.png';
import logoCO from './logos-small/CO.png';
import logoCP from './logos-small/CP.png';
import logoCQ from './logos-small/CQ.png';
import logoCR from './logos-small/CR.png';
import logoCS from './logos-small/CS.png';
import logoCT from './logos-small/CT.png';
import logoCU from './logos-small/CU.png';
import logoCV from './logos-small/CV.png';
import logoCW from './logos-small/CW.png';
import logoCX from './logos-small/CX.png';
import logoCY from './logos-small/CY.png';
import logoCZ from './logos-small/CZ.png';
const logoD0 = unkwnown;
import logoD1 from './logos-small/D1.png';
import logoD2 from './logos-small/D2.png';
import logoD3 from './logos-small/D3.png';
import logoD4 from './logos-small/D4.png';
import logoD5 from './logos-small/D5.png';
import logoD6 from './logos-small/D6.png';
import logoD7 from './logos-small/D7.png';
import logoD8 from './logos-small/D8.png';
import logoD9 from './logos-small/D9.png';
import logoDA from './logos-small/DA.png';
import logoDB from './logos-small/DB.png';
import logoDC from './logos-small/DC.png';
import logoDD from './logos-small/DD.png';
import logoDE from './logos-small/DE.png';
import logoDF from './logos-small/DF.png';
import logoDG from './logos-small/DG.png';
import logoDH from './logos-small/DH.png';
import logoDI from './logos-small/DI.png';
import logoDJ from './logos-small/DJ.png';
import logoDK from './logos-small/DK.png';
import logoDL from './logos-small/DL.png';
import logoDM from './logos-small/DM.png';
import logoDN from './logos-small/DN.png';
import logoDO from './logos-small/DO.png';
import logoDP from './logos-small/DP.png';
import logoDQ from './logos-small/DQ.png';
import logoDR from './logos-small/DR.png';
import logoDS from './logos-small/DS.png';
import logoDT from './logos-small/DT.png';
import logoDU from './logos-small/DU.png';
import logoDV from './logos-small/DV.png';
import logoDW from './logos-small/DW.png';
import logoDX from './logos-small/DX.png';
import logoDY from './logos-small/DY.png';
import logoDZ from './logos-small/DZ.png';
const logoE0 = unkwnown;
import logoE2 from './logos-small/E2.png';
import logoE3 from './logos-small/E3.png';
import logoE4 from './logos-small/E4.png';
import logoE5 from './logos-small/E5.png';
import logoE6 from './logos-small/E6.png';
import logoE7 from './logos-small/E7.png';
import logoE8 from './logos-small/E8.png';
import logoE9 from './logos-small/E9.png';
import logoEA from './logos-small/EA.png';
import logoEB from './logos-small/EB.png';
import logoEC from './logos-small/EC.png';
import logoED from './logos-small/ED.png';
import logoEE from './logos-small/EE.png';
import logoEF from './logos-small/EF.png';
import logoEG from './logos-small/EG.png';
import logoEH from './logos-small/EH.png';
import logoEI from './logos-small/EI.png';
import logoEJ from './logos-small/EJ.png';
import logoEK from './logos-small/EK.png';
import logoEL from './logos-small/EL.png';
import logoEM from './logos-small/EM.png';
import logoEN from './logos-small/EN.png';
import logoEO from './logos-small/EO.png';
import logoEP from './logos-small/EP.png';
import logoEQ from './logos-small/EQ.png';
import logoER from './logos-small/ER.png';
import logoES from './logos-small/ES.png';
import logoET from './logos-small/ET.png';
import logoEU from './logos-small/EU.png';
import logoEV from './logos-small/EV.png';
import logoEW from './logos-small/EW.png';
import logoEX from './logos-small/EX.png';
import logoEY from './logos-small/EY.png';
import logoEZ from './logos-small/EZ.png';
import logoF2 from './logos-small/F2.png';
import logoF3 from './logos-small/F3.png';
import logoF4 from './logos-small/F4.png';
import logoF5 from './logos-small/F5.png';
import logoF6 from './logos-small/F6.png';
import logoF7 from './logos-small/F7.png';
import logoF8 from './logos-small/F8.png';
import logoF9 from './logos-small/F9.png';
import logoFA from './logos-small/FA.png';
import logoFB from './logos-small/FB.png';
import logoFC from './logos-small/FC.png';
import logoFD from './logos-small/FD.png';
import logoFE from './logos-small/FE.png';
import logoFG from './logos-small/FG.png';
import logoFH from './logos-small/FH.png';
import logoFI from './logos-small/FI.png';
import logoFJ from './logos-small/FJ.png';
import logoFK from './logos-small/FK.png';
import logoFL from './logos-small/FL.png';
import logoFM from './logos-small/FM.png';
import logoFN from './logos-small/FN.png';
import logoFO from './logos-small/FO.png';
import logoFP from './logos-small/FP.png';
import logoFQ from './logos-small/FQ.png';
import logoFR from './logos-small/FR.png';
import logoFS from './logos-small/FS.png';
import logoFT from './logos-small/FT.png';
import logoFU from './logos-small/FU.png';
import logoFV from './logos-small/FV.png';
import logoFW from './logos-small/FW.png';
import logoFX from './logos-small/FX.png';
import logoFY from './logos-small/FY.png';
import logoFZ from './logos-small/FZ.png';
const logoG0 = unkwnown;
import logoG1 from './logos-small/G1.png';
import logoG2 from './logos-small/G2.png';
import logoG3 from './logos-small/G3.png';
import logoG4 from './logos-small/G4.png';
import logoG5 from './logos-small/G5.png';
import logoG6 from './logos-small/G6.png';
import logoG7 from './logos-small/G7.png';
import logoG8 from './logos-small/G8.png';
import logoG9 from './logos-small/G9.png';
import logoGA from './logos-small/GA.png';
import logoGB from './logos-small/GB.png';
import logoGC from './logos-small/GC.png';
import logoGD from './logos-small/GD.png';
import logoGE from './logos-small/GE.png';
import logoGF from './logos-small/GF.png';
import logoGG from './logos-small/GG.png';
import logoGH from './logos-small/GH.png';
import logoGI from './logos-small/GI.png';
import logoGJ from './logos-small/GJ.png';
import logoGK from './logos-small/GK.png';
import logoGL from './logos-small/GL.png';
import logoGM from './logos-small/GM.png';
import logoGN from './logos-small/GN.png';
import logoGO from './logos-small/GO.png';
import logoGP from './logos-small/GP.png';
import logoGQ from './logos-small/GQ.png';
import logoGR from './logos-small/GR.png';
import logoGS from './logos-small/GS.png';
import logoGT from './logos-small/GT.png';
import logoGU from './logos-small/GU.png';
import logoGV from './logos-small/GV.png';
import logoGW from './logos-small/GW.png';
import logoGX from './logos-small/GX.png';
import logoGY from './logos-small/GY.png';
import logoGZ from './logos-small/GZ.png';
import logoH1 from './logos-small/H1.png';
import logoH2 from './logos-small/H2.png';
import logoH3 from './logos-small/H3.png';
import logoH4 from './logos-small/H4.png';
import logoH5 from './logos-small/H5.png';
import logoH6 from './logos-small/H6.png';
import logoH7 from './logos-small/H7.png';
import logoH8 from './logos-small/H8.png';
import logoH9 from './logos-small/H9.png';
import logoHA from './logos-small/HA.png';
import logoHB from './logos-small/HB.png';
import logoHC from './logos-small/HC.png';
import logoHD from './logos-small/HD.png';
import logoHE from './logos-small/HE.png';
import logoHF from './logos-small/HF.png';
import logoHG from './logos-small/HG.png';
import logoHH from './logos-small/HH.png';
import logoHI from './logos-small/HI.png';
import logoHJ from './logos-small/HJ.png';
import logoHK from './logos-small/HK.png';
import logoHM from './logos-small/HM.png';
import logoHN from './logos-small/HN.png';
import logoHO from './logos-small/HO.png';
import logoHP from './logos-small/HP.png';
import logoHQ from './logos-small/HQ.png';
import logoHR from './logos-small/HR.png';
import logoHS from './logos-small/HS.png';
import logoHT from './logos-small/HT.png';
import logoHU from './logos-small/HU.png';
import logoHV from './logos-small/HV.png';
import logoHW from './logos-small/HW.png';
import logoHX from './logos-small/HX.png';
import logoHY from './logos-small/HY.png';
import logoHZ from './logos-small/HZ.png';
import logoI1 from './logos-small/I1.png';
import logoI2 from './logos-small/I2.png';
import logoI3 from './logos-small/I3.png';
import logoI4 from './logos-small/I4.png';
import logoI5 from './logos-small/I5.png';
import logoI6 from './logos-small/I6.png';
import logoI7 from './logos-small/I7.png';
import logoI8 from './logos-small/I8.png';
import logoI9 from './logos-small/I9.png';
import logoIA from './logos-small/IA.png';
import logoIB from './logos-small/IB.png';
import logoIC from './logos-small/IC.png';
import logoID from './logos-small/ID.png';
import logoIE from './logos-small/IE.png';
import logoIF from './logos-small/IF.png';
import logoIG from './logos-small/IG.png';
import logoIH from './logos-small/IH.png';
import logoII from './logos-small/II.png';
import logoIJ from './logos-small/IJ.png';
import logoIK from './logos-small/IK.png';
import logoIL from './logos-small/IL.png';
import logoIM from './logos-small/IM.png';
import logoIN from './logos-small/IN.png';
import logoIO from './logos-small/IO.png';
import logoIP from './logos-small/IP.png';
import logoIQ from './logos-small/IQ.png';
import logoIR from './logos-small/IR.png';
import logoIS from './logos-small/IS.png';
import logoIT from './logos-small/IT.png';
import logoIU from './logos-small/IU.png';
import logoIV from './logos-small/IV.png';
import logoIW from './logos-small/IW.png';
import logoIX from './logos-small/IX.png';
import logoIY from './logos-small/IY.png';
import logoIZ from './logos-small/IZ.png';
const logoJ0 = unkwnown;
import logoJ1 from './logos-small/J1.png';
import logoJ2 from './logos-small/J2.png';
import logoJ3 from './logos-small/J3.png';
import logoJ4 from './logos-small/J4.png';
import logoJ5 from './logos-small/J5.png';
import logoJ6 from './logos-small/J6.png';
import logoJ7 from './logos-small/J7.png';
import logoJ8 from './logos-small/J8.png';
import logoJ9 from './logos-small/J9.png';
import logoJA from './logos-small/JA.png';
import logoJB from './logos-small/JB.png';
import logoJC from './logos-small/JC.png';
import logoJD from './logos-small/JD.png';
import logoJE from './logos-small/JE.png';
import logoJF from './logos-small/JF.png';
import logoJG from './logos-small/JG.png';
import logoJH from './logos-small/JH.png';
import logoJI from './logos-small/JI.png';
import logoJJ from './logos-small/JJ.png';
import logoJK from './logos-small/JK.png';
import logoJL from './logos-small/JL.png';
import logoJM from './logos-small/JM.png';
import logoJN from './logos-small/JN.png';
import logoJO from './logos-small/JO.png';
import logoJP from './logos-small/JP.png';
import logoJQ from './logos-small/JQ.png';
import logoJR from './logos-small/JR.png';
import logoJS from './logos-small/JS.png';
import logoJT from './logos-small/JT.png';
import logoJU from './logos-small/JU.png';
import logoJV from './logos-small/JV.png';
import logoJW from './logos-small/JW.png';
import logoJX from './logos-small/JX.png';
import logoJY from './logos-small/JY.png';
import logoJZ from './logos-small/JZ.png';
import logoK1 from './logos-small/K1.png';
import logoK2 from './logos-small/K2.png';
import logoK3 from './logos-small/K3.png';
import logoK4 from './logos-small/K4.png';
import logoK5 from './logos-small/K5.png';
import logoK6 from './logos-small/K6.png';
import logoK7 from './logos-small/K7.png';
import logoK8 from './logos-small/K8.png';
import logoK9 from './logos-small/K9.png';
import logoKA from './logos-small/KA.png';
import logoKB from './logos-small/KB.png';
import logoKC from './logos-small/KC.png';
import logoKD from './logos-small/KD.png';
import logoKE from './logos-small/KE.png';
import logoKF from './logos-small/KF.png';
import logoKG from './logos-small/KG.png';
import logoKH from './logos-small/KH.png';
import logoKI from './logos-small/KI.png';
import logoKJ from './logos-small/KJ.png';
import logoKK from './logos-small/KK.png';
import logoKL from './logos-small/KL.png';
import logoKM from './logos-small/KM.png';
import logoKN from './logos-small/KN.png';
import logoKO from './logos-small/KO.png';
import logoKP from './logos-small/KP.png';
import logoKQ from './logos-small/KQ.png';
import logoKR from './logos-small/KR.png';
import logoKS from './logos-small/KS.png';
import logoKT from './logos-small/KT.png';
import logoKU from './logos-small/KU.png';
import logoKV from './logos-small/KV.png';
import logoKW from './logos-small/KW.png';
import logoKX from './logos-small/KX.png';
import logoKY from './logos-small/KY.png';
import logoKZ from './logos-small/KZ.png';
import logoL2 from './logos-small/L2.png';
import logoL3 from './logos-small/L3.png';
import logoL4 from './logos-small/L4.png';
import logoL5 from './logos-small/L5.png';
import logoL6 from './logos-small/L6.png';
import logoL7 from './logos-small/L7.png';
import logoL8 from './logos-small/L8.png';
import logoL9 from './logos-small/L9.png';
import logoLA from './logos-small/LA.png';
import logoLB from './logos-small/LB.png';
import logoLC from './logos-small/LC.png';
import logoLD from './logos-small/LD.png';
import logoLE from './logos-small/LE.png';
import logoLF from './logos-small/LF.png';
import logoLG from './logos-small/LG.png';
import logoLH from './logos-small/LH.png';
import logoLI from './logos-small/LI.png';
import logoLJ from './logos-small/LJ.png';
import logoLK from './logos-small/LK.png';
import logoLL from './logos-small/LL.png';
import logoLM from './logos-small/LM.png';
import logoLN from './logos-small/LN.png';
import logoLO from './logos-small/LO.png';
import logoLP from './logos-small/LP.png';
import logoLQ from './logos-small/LQ.png';
import logoLR from './logos-small/LR.png';
import logoLS from './logos-small/LS.png';
import logoLT from './logos-small/LT.png';
import logoLU from './logos-small/LU.png';
import logoLV from './logos-small/LV.png';
import logoLW from './logos-small/LW.png';
import logoLX from './logos-small/LX.png';
import logoLY from './logos-small/LY.png';
import logoLZ from './logos-small/LZ.png';
import logoM0 from './logos-small/M0.png';
import logoM2 from './logos-small/M2.png';
import logoM3 from './logos-small/M3.png';
import logoM4 from './logos-small/M4.png';
import logoM5 from './logos-small/M5.png';
import logoM6 from './logos-small/M6.png';
import logoM7 from './logos-small/M7.png';
import logoM8 from './logos-small/M8.png';
import logoM9 from './logos-small/M9.png';
import logoMA from './logos-small/MA.png';
import logoMB from './logos-small/MB.png';
import logoMC from './logos-small/MC.png';
import logoMD from './logos-small/MD.png';
import logoME from './logos-small/ME.png';
import logoMF from './logos-small/MF.png';
import logoMG from './logos-small/MG.png';
import logoMH from './logos-small/MH.png';
import logoMI from './logos-small/MI.png';
import logoMJ from './logos-small/MJ.png';
import logoMK from './logos-small/MK.png';
import logoML from './logos-small/ML.png';
import logoMM from './logos-small/MM.png';
import logoMN from './logos-small/MN.png';
import logoMO from './logos-small/MO.png';
import logoMP from './logos-small/MP.png';
import logoMQ from './logos-small/MQ.png';
import logoMR from './logos-small/MR.png';
import logoMS from './logos-small/MS.png';
import logoMT from './logos-small/MT.png';
import logoMU from './logos-small/MU.png';
import logoMV from './logos-small/MV.png';
import logoMW from './logos-small/MW.png';
import logoMX from './logos-small/MX.png';
import logoMY from './logos-small/MY.png';
import logoMZ from './logos-small/MZ.png';
import logoN2 from './logos-small/N2.png';
import logoN3 from './logos-small/N3.png';
import logoN4 from './logos-small/N4.png';
import logoN5 from './logos-small/N5.png';
import logoN6 from './logos-small/N6.png';
import logoN7 from './logos-small/N7.png';
import logoN8 from './logos-small/N8.png';
import logoN9 from './logos-small/N9.png';
import logoNA from './logos-small/NA.png';
import logoNB from './logos-small/NB.png';
import logoNC from './logos-small/NC.png';
import logoNE from './logos-small/NE.png';
import logoNF from './logos-small/NF.png';
import logoNG from './logos-small/NG.png';
import logoNH from './logos-small/NH.png';
import logoNI from './logos-small/NI.png';
import logoNK from './logos-small/NK.png';
import logoNL from './logos-small/NL.png';
import logoNM from './logos-small/NM.png';
import logoNN from './logos-small/NN.png';
import logoNO from './logos-small/NO.png';
import logoNP from './logos-small/NP.png';
import logoNQ from './logos-small/NQ.png';
import logoNR from './logos-small/NR.png';
import logoNS from './logos-small/NS.png';
import logoNT from './logos-small/NT.png';
import logoNU from './logos-small/NU.png';
import logoNV from './logos-small/NV.png';
import logoNW from './logos-small/NW.png';
import logoNX from './logos-small/NX.png';
import logoNY from './logos-small/NY.png';
import logoNZ from './logos-small/NZ.png';
import logoO2 from './logos-small/O2.png';
import logoO3 from './logos-small/O3.png';
import logoO4 from './logos-small/O4.png';
import logoO5 from './logos-small/O5.png';
import logoO6 from './logos-small/O6.png';
import logoO7 from './logos-small/O7.png';
import logoO8 from './logos-small/O8.png';
import logoO9 from './logos-small/O9.png';
import logoOA from './logos-small/OA.png';
import logoOB from './logos-small/OB.png';
import logoOC from './logos-small/OC.png';
import logoOD from './logos-small/OD.png';
import logoOE from './logos-small/OE.png';
import logoOF from './logos-small/OF.png';
import logoOG from './logos-small/OG.png';
import logoOH from './logos-small/OH.png';
import logoOI from './logos-small/OI.png';
import logoOJ from './logos-small/OJ.png';
import logoOK from './logos-small/OK.png';
import logoOL from './logos-small/OL.png';
import logoOM from './logos-small/OM.png';
import logoON from './logos-small/ON.png';
import logoOO from './logos-small/OO.png';
import logoOP from './logos-small/OP.png';
import logoOQ from './logos-small/OQ.png';
import logoOR from './logos-small/OR.png';
import logoOS from './logos-small/OS.png';
import logoOT from './logos-small/OT.png';
import logoOU from './logos-small/OU.png';
import logoOV from './logos-small/OV.png';
import logoOW from './logos-small/OW.png';
import logoOX from './logos-small/OX.png';
import logoOY from './logos-small/OY.png';
import logoOZ from './logos-small/OZ.png';
import logoP0 from './logos-small/P0.png';
import logoP1 from './logos-small/P1.png';
import logoP2 from './logos-small/P2.png';
import logoP3 from './logos-small/P3.png';
import logoP4 from './logos-small/P4.png';
import logoP5 from './logos-small/P5.png';
import logoP6 from './logos-small/P6.png';
import logoP7 from './logos-small/P7.png';
import logoP8 from './logos-small/P8.png';
import logoP9 from './logos-small/P9.png';
import logoPA from './logos-small/PA.png';
import logoPB from './logos-small/PB.png';
import logoPC from './logos-small/PC.png';
import logoPD from './logos-small/PD.png';
import logoPE from './logos-small/PE.png';
import logoPF from './logos-small/PF.png';
import logoPG from './logos-small/PG.png';
import logoPH from './logos-small/PH.png';
import logoPI from './logos-small/PI.png';
import logoPJ from './logos-small/PJ.png';
import logoPK from './logos-small/PK.png';
import logoPL from './logos-small/PL.png';
import logoPM from './logos-small/PM.png';
import logoPN from './logos-small/PN.png';
import logoPO from './logos-small/PO.png';
import logoPP from './logos-small/PP.png';
import logoPQ from './logos-small/PQ.png';
import logoPR from './logos-small/PR.png';
import logoPS from './logos-small/PS.png';
import logoPT from './logos-small/PT.png';
import logoPU from './logos-small/PU.png';
import logoPV from './logos-small/PV.png';
import logoPW from './logos-small/PW.png';
import logoPX from './logos-small/PX.png';
import logoPY from './logos-small/PY.png';
import logoPZ from './logos-small/PZ.png';
const logoQ0 = unkwnown;
import logoQ2 from './logos-small/Q2.png';
import logoQ3 from './logos-small/Q3.png';
import logoQ4 from './logos-small/Q4.png';
import logoQ5 from './logos-small/Q5.png';
import logoQ6 from './logos-small/Q6.png';
import logoQ7 from './logos-small/Q7.png';
import logoQ8 from './logos-small/Q8.png';
import logoQ9 from './logos-small/Q9.png';
import logoQA from './logos-small/QA.png';
import logoQB from './logos-small/QB.png';
import logoQC from './logos-small/QC.png';
import logoQD from './logos-small/QD.png';
import logoQE from './logos-small/QE.png';
import logoQF from './logos-small/QF.png';
import logoQG from './logos-small/QG.png';
import logoQH from './logos-small/QH.png';
import logoQI from './logos-small/QI.png';
import logoQJ from './logos-small/QJ.png';
import logoQK from './logos-small/QK.png';
import logoQL from './logos-small/QL.png';
import logoQM from './logos-small/QM.png';
import logoQN from './logos-small/QN.png';
import logoQO from './logos-small/QO.png';
import logoQP from './logos-small/QP.png';
import logoQQ from './logos-small/QQ.png';
import logoQR from './logos-small/QR.png';
import logoQS from './logos-small/QS.png';
import logoQT from './logos-small/QT.png';
import logoQU from './logos-small/QU.png';
import logoQV from './logos-small/QV.png';
import logoQW from './logos-small/QW.png';
import logoQX from './logos-small/QX.png';
import logoQY from './logos-small/QY.png';
import logoQZ from './logos-small/QZ.png';
const logoR0 = unkwnown;
import logoR1 from './logos-small/R1.png';
import logoR2 from './logos-small/R2.png';
import logoR3 from './logos-small/R3.png';
import logoR4 from './logos-small/R4.png';
import logoR5 from './logos-small/R5.png';
import logoR6 from './logos-small/R6.png';
import logoR7 from './logos-small/R7.png';
import logoR8 from './logos-small/R8.png';
import logoR9 from './logos-small/R9.png';
import logoRA from './logos-small/RA.png';
import logoRB from './logos-small/RB.png';
import logoRC from './logos-small/RC.png';
import logoRD from './logos-small/RD.png';
import logoRE from './logos-small/RE.png';
import logoRF from './logos-small/RF.png';
import logoRG from './logos-small/RG.png';
import logoRH from './logos-small/RH.png';
import logoRI from './logos-small/RI.png';
import logoRJ from './logos-small/RJ.png';
import logoRK from './logos-small/RK.png';
import logoRL from './logos-small/RL.png';
import logoRN from './logos-small/RN.png';
import logoRO from './logos-small/RO.png';
import logoRP from './logos-small/RP.png';
import logoRQ from './logos-small/RQ.png';
import logoRR from './logos-small/RR.png';
import logoRS from './logos-small/RS.png';
import logoRT from './logos-small/RT.png';
import logoRU from './logos-small/RU.png';
import logoRV from './logos-small/RV.png';
import logoRX from './logos-small/RX.png';
import logoRY from './logos-small/RY.png';
import logoRZ from './logos-small/RZ.png';
const logoS0 = unkwnown;
import logoS1 from './logos-small/S1.png';
import logoS2 from './logos-small/S2.png';
import logoS3 from './logos-small/S3.png';
import logoS4 from './logos-small/S4.png';
import logoS5 from './logos-small/S5.png';
import logoS6 from './logos-small/S6.png';
import logoS7 from './logos-small/S7.png';
import logoS8 from './logos-small/S8.png';
import logoS9 from './logos-small/S9.png';
import logoSA from './logos-small/SA.png';
import logoSB from './logos-small/SB.png';
import logoSC from './logos-small/SC.png';
import logoSD from './logos-small/SD.png';
import logoSE from './logos-small/SE.png';
import logoSF from './logos-small/SF.png';
import logoSG from './logos-small/SG.png';
import logoSH from './logos-small/SH.png';
import logoSI from './logos-small/SI.png';
import logoSJ from './logos-small/SJ.png';
import logoSK from './logos-small/SK.png';
import logoSL from './logos-small/SL.png';
import logoSM from './logos-small/SM.png';
import logoSN from './logos-small/SN.png';
import logoSO from './logos-small/SO.png';
import logoSP from './logos-small/SP.png';
import logoSQ from './logos-small/SQ.png';
import logoSR from './logos-small/SR.png';
import logoSS from './logos-small/SS.png';
import logoST from './logos-small/ST.png';
import logoSU from './logos-small/SU.png';
import logoSV from './logos-small/SV.png';
import logoSW from './logos-small/SW.png';
import logoSX from './logos-small/SX.png';
import logoSY from './logos-small/SY.png';
import logoSZ from './logos-small/SZ.png';
const logoT0 = unkwnown;
import logoT1 from './logos-small/T1.png';
import logoT2 from './logos-small/T2.png';
import logoT3 from './logos-small/T3.png';
import logoT4 from './logos-small/T4.png';
import logoT5 from './logos-small/T5.png';
import logoT6 from './logos-small/T6.png';
import logoT7 from './logos-small/T7.png';
import logoT8 from './logos-small/T8.png';
import logoTA from './logos-small/TA.png';
import logoTB from './logos-small/TB.png';
import logoTC from './logos-small/TC.png';
import logoTD from './logos-small/TD.png';
import logoTE from './logos-small/TE.png';
import logoTF from './logos-small/TF.png';
import logoTG from './logos-small/TG.png';
import logoTH from './logos-small/TH.png';
import logoTI from './logos-small/TI.png';
import logoTJ from './logos-small/TJ.png';
import logoTK from './logos-small/TK.png';
import logoTL from './logos-small/TL.png';
import logoTM from './logos-small/TM.png';
import logoTN from './logos-small/TN.png';
import logoTO from './logos-small/TO.png';
import logoTP from './logos-small/TP.png';
import logoTQ from './logos-small/TQ.png';
import logoTR from './logos-small/TR.png';
import logoTS from './logos-small/TS.png';
import logoTT from './logos-small/TT.png';
import logoTU from './logos-small/TU.png';
import logoTV from './logos-small/TV.png';
import logoTW from './logos-small/TW.png';
import logoTX from './logos-small/TX.png';
import logoTY from './logos-small/TY.png';
import logoTZ from './logos-small/TZ.png';
const logoU0 = unkwnown;
import logoU2 from './logos-small/U2.png';
import logoU3 from './logos-small/U3.png';
import logoU4 from './logos-small/U4.png';
import logoU5 from './logos-small/U5.png';
import logoU6 from './logos-small/U6.png';
import logoU7 from './logos-small/U7.png';
import logoU8 from './logos-small/U8.png';
import logoU9 from './logos-small/U9.png';
import logoUA from './logos-small/UA.png';
import logoUB from './logos-small/UB.png';
import logoUC from './logos-small/UC.png';
import logoUD from './logos-small/UD.png';
import logoUE from './logos-small/UE.png';
import logoUF from './logos-small/UF.png';
import logoUG from './logos-small/UG.png';
import logoUH from './logos-small/UH.png';
import logoUI from './logos-small/UI.png';
import logoUJ from './logos-small/UJ.png';
import logoUK from './logos-small/UK.png';
import logoUL from './logos-small/UL.png';
import logoUM from './logos-small/UM.png';
import logoUN from './logos-small/UN.png';
import logoUO from './logos-small/UO.png';
import logoUP from './logos-small/UP.png';
import logoUQ from './logos-small/UQ.png';
import logoUR from './logos-small/UR.png';
import logoUS from './logos-small/US.png';
import logoUT from './logos-small/UT.png';
import logoUU from './logos-small/UU.png';
import logoUV from './logos-small/UV.png';
import logoUW from './logos-small/UW.png';
import logoUX from './logos-small/UX.png';
import logoUY from './logos-small/UY.png';
import logoUZ from './logos-small/UZ.png';
import logoV0 from './logos-small/V0.png';
import logoV2 from './logos-small/V2.png';
import logoV3 from './logos-small/V3.png';
import logoV4 from './logos-small/V4.png';
import logoV5 from './logos-small/V5.png';
import logoV6 from './logos-small/V6.png';
import logoV7 from './logos-small/V7.png';
import logoV8 from './logos-small/V8.png';
import logoV9 from './logos-small/V9.png';
import logoVA from './logos-small/VA.png';
import logoVB from './logos-small/VB.png';
import logoVC from './logos-small/VC.png';
import logoVD from './logos-small/VD.png';
import logoVE from './logos-small/VE.png';
import logoVF from './logos-small/VF.png';
import logoVG from './logos-small/VG.png';
import logoVH from './logos-small/VH.png';
import logoVI from './logos-small/VI.png';
import logoVJ from './logos-small/VJ.png';
import logoVK from './logos-small/VK.png';
import logoVL from './logos-small/VL.png';
import logoVM from './logos-small/VM.png';
import logoVN from './logos-small/VN.png';
import logoVO from './logos-small/VO.png';
import logoVP from './logos-small/VP.png';
import logoVQ from './logos-small/VQ.png';
import logoVR from './logos-small/VR.png';
import logoVS from './logos-small/VS.png';
import logoVT from './logos-small/VT.png';
import logoVU from './logos-small/VU.png';
import logoVV from './logos-small/VV.png';
import logoVW from './logos-small/VW.png';
import logoVX from './logos-small/VX.png';
import logoVY from './logos-small/VY.png';
import logoVZ from './logos-small/VZ.png';
import logoW2 from './logos-small/W2.png';
import logoW3 from './logos-small/W3.png';
import logoW4 from './logos-small/W4.png';
import logoW5 from './logos-small/W5.png';
import logoW6 from './logos-small/W6.png';
import logoW7 from './logos-small/W7.png';
import logoW8 from './logos-small/W8.png';
import logoW9 from './logos-small/W9.png';
import logoWA from './logos-small/WA.png';
import logoWB from './logos-small/WB.png';
import logoWC from './logos-small/WC.png';
import logoWD from './logos-small/WD.png';
import logoWE from './logos-small/WE.png';
import logoWF from './logos-small/WF.png';
import logoWG from './logos-small/WG.png';
import logoWH from './logos-small/WH.png';
import logoWI from './logos-small/WI.png';
import logoWJ from './logos-small/WJ.png';
import logoWK from './logos-small/WK.png';
import logoWL from './logos-small/WL.png';
import logoWM from './logos-small/WM.png';
import logoWN from './logos-small/WN.png';
import logoWO from './logos-small/WO.png';
import logoWP from './logos-small/WP.png';
import logoWQ from './logos-small/WQ.png';
import logoWR from './logos-small/WR.png';
import logoWS from './logos-small/WS.png';
import logoWT from './logos-small/WT.png';
import logoWU from './logos-small/WU.png';
import logoWV from './logos-small/WV.png';
import logoWW from './logos-small/WW.png';
import logoWX from './logos-small/WX.png';
import logoWY from './logos-small/WY.png';
import logoWZ from './logos-small/WZ.png';
const logoX0 = unkwnown;
import logoX1 from './logos-small/X1.png';
import logoX2 from './logos-small/X2.png';
import logoX3 from './logos-small/X3.png';
import logoX4 from './logos-small/X4.png';
import logoX5 from './logos-small/X5.png';
import logoX6 from './logos-small/X6.png';
import logoX7 from './logos-small/X7.png';
import logoX8 from './logos-small/X8.png';
import logoX9 from './logos-small/X9.png';
import logoXA from './logos-small/XA.png';
import logoXB from './logos-small/XB.png';
import logoXC from './logos-small/XC.png';
import logoXD from './logos-small/XD.png';
import logoXE from './logos-small/XE.png';
import logoXF from './logos-small/XF.png';
import logoXG from './logos-small/XG.png';
import logoXH from './logos-small/XH.png';
import logoXI from './logos-small/XI.png';
import logoXJ from './logos-small/XJ.png';
import logoXK from './logos-small/XK.png';
import logoXL from './logos-small/XL.png';
import logoXM from './logos-small/XM.png';
import logoXN from './logos-small/XN.png';
import logoXO from './logos-small/XO.png';
import logoXP from './logos-small/XP.png';
import logoXQ from './logos-small/XQ.png';
import logoXR from './logos-small/XR.png';
import logoXS from './logos-small/XS.png';
import logoXT from './logos-small/XT.png';
import logoXU from './logos-small/XU.png';
import logoXV from './logos-small/XV.png';
import logoXW from './logos-small/XW.png';
import logoXX from './logos-small/XX.png';
import logoXY from './logos-small/XY.png';
import logoXZ from './logos-small/XZ.png';
const logoY0 = unkwnown;
import logoY2 from './logos-small/Y2.png';
import logoY4 from './logos-small/Y4.png';
import logoY5 from './logos-small/Y5.png';
import logoY6 from './logos-small/Y6.png';
import logoY7 from './logos-small/Y7.png';
import logoY8 from './logos-small/Y8.png';
import logoY9 from './logos-small/Y9.png';
import logoYA from './logos-small/YA.png';
import logoYB from './logos-small/YB.png';
import logoYC from './logos-small/YC.png';
import logoYD from './logos-small/YD.png';
import logoYE from './logos-small/YE.png';
import logoYF from './logos-small/YF.png';
import logoYG from './logos-small/YG.png';
import logoYH from './logos-small/YH.png';
import logoYI from './logos-small/YI.png';
import logoYJ from './logos-small/YJ.png';
import logoYK from './logos-small/YK.png';
import logoYL from './logos-small/YL.png';
import logoYM from './logos-small/YM.png';
import logoYN from './logos-small/YN.png';
import logoYO from './logos-small/YO.png';
import logoYP from './logos-small/YP.png';
import logoYQ from './logos-small/YQ.png';
import logoYR from './logos-small/YR.png';
import logoYS from './logos-small/YS.png';
import logoYT from './logos-small/YT.png';
import logoYU from './logos-small/YU.png';
import logoYV from './logos-small/YV.png';
import logoYW from './logos-small/YW.png';
import logoYX from './logos-small/YX.png';
import logoYZ from './logos-small/YZ.png';
import logoZ1 from './logos-small/Z1.png';
import logoZ2 from './logos-small/Z2.png';
import logoZ3 from './logos-small/Z3.png';
import logoZ4 from './logos-small/Z4.png';
import logoZ5 from './logos-small/Z5.png';
import logoZ6 from './logos-small/Z6.png';
import logoZ7 from './logos-small/Z7.png';
import logoZ8 from './logos-small/Z8.png';
import logoZ9 from './logos-small/Z9.png';
import logoZA from './logos-small/ZA.png';
import logoZB from './logos-small/ZB.png';
import logoZC from './logos-small/ZC.png';
import logoZD from './logos-small/ZD.png';
import logoZE from './logos-small/ZE.png';
import logoZF from './logos-small/ZF.png';
import logoZG from './logos-small/ZG.png';
import logoZH from './logos-small/ZH.png';
import logoZI from './logos-small/ZI.png';
import logoZJ from './logos-small/ZJ.png';
import logoZK from './logos-small/ZK.png';
import logoZL from './logos-small/ZL.png';
import logoZM from './logos-small/ZM.png';
import logoZN from './logos-small/ZN.png';
import logoZO from './logos-small/ZO.png';
import logoZP from './logos-small/ZP.png';
import logoZQ from './logos-small/ZQ.png';
import logoZR from './logos-small/ZR.png';
import logoZS from './logos-small/ZS.png';
import logoZT from './logos-small/ZT.png';
import logoZU from './logos-small/ZU.png';
import logoZV from './logos-small/ZV.png';
import logoZW from './logos-small/ZW.png';
import logoZX from './logos-small/ZX.png';
import logoZY from './logos-small/ZY.png';

export default {unkwnown, '0B': logo0B, '0E': logo0E, '0Q': logo0Q, '0V': logo0V, '01': logo01, '1A': logo1A,
    '1B': logo1B, '1C': logo1C, '1D': logo1D, '1E': logo1E, '1F': logo1F, '1G': logo1G, '1H': logo1H, '1I': logo1I,
    '1J': logo1J, '1K': logo1K, '1L': logo1L, '1M': logo1M, '1N': logo1N, '1P': logo1P, '1Q': logo1Q, '1R': logo1R,
    '1S': logo1S, '1T': logo1T, '1U': logo1U, '1X': logo1X, '1Y': logo1Y, '1Z': logo1Z, '02': logo02, '2A': logo2A,
    '2B': logo2B, '2C': logo2C, '2D': logo2D, '2E': logo2E, '2F': logo2F, '2G': logo2G, '2H': logo2H, '2I': logo2I,
    '2J': logo2J, '2K': logo2K, '2L': logo2L, '2M': logo2M, '2N': logo2N, '2O': logo2O, '2P': logo2P, '2Q': logo2Q,
    '2R': logo2R, '2S': logo2S, '2T': logo2T, '2U': logo2U, '2V': logo2V, '2W': logo2W, '2Y': logo2Y, '2Z': logo2Z,
    '3A': logo3A, '3B': logo3B, '3C': logo3C, '3D': logo3D, '3E': logo3E, '3F': logo3F, '3G': logo3G, '3H': logo3H,
    '3I': logo3I, '3J': logo3J, '3K': logo3K, '3L': logo3L, '3M': logo3M, '3N': logo3N, '3O': logo3O, '3P': logo3P,
    '3Q': logo3Q, '3R': logo3R, '3S': logo3S, '3T': logo3T, '3U': logo3U, '3V': logo3V, '3W': logo3W, '3X': logo3X,
    '3Y': logo3Y, '3Z': logo3Z, '04': logo04, '4A': logo4A, '4B': logo4B, '4C': logo4C, '4D': logo4D, '4E': logo4E,
    '4G': logo4G, '4H': logo4H, '4I': logo4I, '4J': logo4J, '4K': logo4K, '4L': logo4L, '4M': logo4M, '4N': logo4N,
    '4O': logo4O, '4P': logo4P, '4Q': logo4Q, '4R': logo4R, '4T': logo4T, '4U': logo4U, '4V': logo4V, '4W': logo4W,
    '4X': logo4X, '4Y': logo4Y, '4Z': logo4Z, '5A': logo5A, '5B': logo5B, '5C': logo5C, '5D': logo5D, '5E': logo5E,
    '5F': logo5F, '5G': logo5G, '5H': logo5H, '5I': logo5I, '5J': logo5J, '5K': logo5K, '5L': logo5L, '5M': logo5M,
    '5N': logo5N, '5O': logo5O, '5P': logo5P, '5Q': logo5Q, '5R': logo5R, '5S': logo5S, '5T': logo5T, '5U': logo5U,
    '5V': logo5V, '5W': logo5W, '5X': logo5X, '5Y': logo5Y, '5Z': logo5Z, '6A': logo6A, '6B': logo6B, '6C': logo6C,
    '6D': logo6D, '6E': logo6E, '6F': logo6F, '6G': logo6G, '6H': logo6H, '6I': logo6I, '6J': logo6J, '6K': logo6K,
    '6L': logo6L, '6M': logo6M, '6N': logo6N, '6O': logo6O, '6P': logo6P, '6Q': logo6Q, '6R': logo6R, '6S': logo6S,
    '6T': logo6T, '6U': logo6U, '6V': logo6V, '6W': logo6W, '6X': logo6X, '6Y': logo6Y, '6Z': logo6Z, '7A': logo7A,
    '7B': logo7B, '7C': logo7C, '7D': logo7D, '7E': logo7E, '7F': logo7F, '7G': logo7G, '7H': logo7H, '7I': logo7I,
    '7J': logo7J, '7K': logo7K, '7L': logo7L, '7M': logo7M, '7N': logo7N, '7O': logo7O, '7P': logo7P, '7Q': logo7Q,
    '7R': logo7R, '7T': logo7T, '7U': logo7U, '7V': logo7V, '7W': logo7W, '7Y': logo7Y, '7Z': logo7Z, '8A': logo8A,
    '8B': logo8B, '8C': logo8C, '8D': logo8D, '8E': logo8E, '8F': logo8F, '8G': logo8G, '8H': logo8H, '8I': logo8I,
    '8J': logo8J, '8K': logo8K, '8L': logo8L, '8M': logo8M, '8N': logo8N, '8O': logo8O, '8P': logo8P, '8Q': logo8Q,
    '8R': logo8R, '8S': logo8S, '8T': logo8T, '8U': logo8U, '8V': logo8V, '8W': logo8W, '8Y': logo8Y, '8Z': logo8Z,
    '9A': logo9A, '9B': logo9B, '9C': logo9C, '9D': logo9D, '9E': logo9E, '9F': logo9F, '9G': logo9G, '9H': logo9H,
    '9I': logo9I, '9J': logo9J, '9K': logo9K, '9L': logo9L, '9M': logo9M, '9N': logo9N, '9O': logo9O, '9P': logo9P,
    '9Q': logo9Q, '9R': logo9R, '9S': logo9S, '9T': logo9T, '9U': logo9U, '9V': logo9V, '9W': logo9W, '9X': logo9X,
    '9Y': logo9Y, A0: logoA0, A1: logoA1, A2: logoA2, A3: logoA3, A4: logoA4, A5: logoA5, A6: logoA6, A7: logoA7,
    A8: logoA8, A9: logoA9, AA: logoAA, AB: logoAB, AC: logoAC, AD: logoAD, AE: logoAE, AF: logoAF, AG: logoAG,
    AH: logoAH, AI: logoAI, AJ: logoAJ, AK: logoAK, AL: logoAL, AM: logoAM, AN: logoAN, AO: logoAO, AP: logoAP,
    AQ: logoAQ, AR: logoAR, AS: logoAS, AT: logoAT, AU: logoAU, AV: logoAV, AW: logoAW, AX: logoAX, AY: logoAY,
    AZ: logoAZ, B0: logoB0, B2: logoB2, B3: logoB3, B4: logoB4, B5: logoB5, B6: logoB6, B7: logoB7, B8: logoB8,
    B9: logoB9, BA: logoBA, BB: logoBB, BC: logoBC, BD: logoBD, BE: logoBE, BF: logoBF, BG: logoBG, BH: logoBH,
    BI: logoBI, BJ: logoBJ, BK: logoBK, BL: logoBL, BM: logoBM, BN: logoBN, BO: logoBO, BP: logoBP, BQ: logoBQ,
    BR: logoBR, BS: logoBS, BT: logoBT, BU: logoBU, BV: logoBV, BW: logoBW, BX: logoBX, BY: logoBY, BZ: logoBZ,
    C0: logoC0, C2: logoC2, C3: logoC3, C4: logoC4, C5: logoC5, C6: logoC6, C7: logoC7, C8: logoC8, C9: logoC9,
    CA: logoCA, CB: logoCB, CC: logoCC, CD: logoCD, CE: logoCE, CF: logoCF, CG: logoCG, CH: logoCH, CI: logoCI,
    CJ: logoCJ, CK: logoCK, CL: logoCL, CM: logoCM, CN: logoCN, CO: logoCO, CP: logoCP, CQ: logoCQ, CR: logoCR,
    CS: logoCS, CT: logoCT, CU: logoCU, CV: logoCV, CW: logoCW, CX: logoCX, CY: logoCY, CZ: logoCZ, D0: logoD0,
    D1: logoD1, D2: logoD2, D3: logoD3, D4: logoD4, D5: logoD5, D6: logoD6, D7: logoD7, D8: logoD8, D9: logoD9,
    DA: logoDA, DB: logoDB, DC: logoDC, DD: logoDD, DE: logoDE, DF: logoDF, DG: logoDG, DH: logoDH, DI: logoDI,
    DJ: logoDJ, DK: logoDK, DL: logoDL, DM: logoDM, DN: logoDN, DO: logoDO, DP: logoDP, DQ: logoDQ, DR: logoDR,
    DS: logoDS, DT: logoDT, DU: logoDU, DV: logoDV, DW: logoDW, DX: logoDX, DY: logoDY, DZ: logoDZ, E0: logoE0,
    E2: logoE2, E3: logoE3, E4: logoE4, E5: logoE5, E6: logoE6, E7: logoE7, E8: logoE8, E9: logoE9, EA: logoEA,
    EB: logoEB, EC: logoEC, ED: logoED, EE: logoEE, EF: logoEF, EG: logoEG, EH: logoEH, EI: logoEI, EJ: logoEJ,
    EK: logoEK, EL: logoEL, EM: logoEM, EN: logoEN, EO: logoEO, EP: logoEP, EQ: logoEQ, ER: logoER, ES: logoES,
    ET: logoET, EU: logoEU, EV: logoEV, EW: logoEW, EX: logoEX, EY: logoEY, EZ: logoEZ, F2: logoF2, F3: logoF3,
    F4: logoF4, F5: logoF5, F6: logoF6, F7: logoF7, F8: logoF8, F9: logoF9, FA: logoFA, FB: logoFB, FC: logoFC,
    FD: logoFD, FE: logoFE, FG: logoFG, FH: logoFH, FI: logoFI, FJ: logoFJ, FK: logoFK, FL: logoFL, FM: logoFM,
    FN: logoFN, FO: logoFO, FP: logoFP, FQ: logoFQ, FR: logoFR, FS: logoFS, FT: logoFT, FU: logoFU, FV: logoFV,
    FW: logoFW, FX: logoFX, FY: logoFY, FZ: logoFZ, G0: logoG0, G1: logoG1, G2: logoG2, G3: logoG3, G4: logoG4,
    G5: logoG5, G6: logoG6, G7: logoG7, G8: logoG8, G9: logoG9, GA: logoGA, GB: logoGB, GC: logoGC, GD: logoGD,
    GE: logoGE, GF: logoGF, GG: logoGG, GH: logoGH, GI: logoGI, GJ: logoGJ, GK: logoGK, GL: logoGL, GM: logoGM,
    GN: logoGN, GO: logoGO, GP: logoGP, GQ: logoGQ, GR: logoGR, GS: logoGS, GT: logoGT, GU: logoGU, GV: logoGV,
    GW: logoGW, GX: logoGX, GY: logoGY, GZ: logoGZ, H1: logoH1, H2: logoH2, H3: logoH3, H4: logoH4, H5: logoH5,
    H6: logoH6, H7: logoH7, H8: logoH8, H9: logoH9, HA: logoHA, HB: logoHB, HC: logoHC, HD: logoHD, HE: logoHE,
    HF: logoHF, HG: logoHG, HH: logoHH, HI: logoHI, HJ: logoHJ, HK: logoHK, HM: logoHM, HN: logoHN, HO: logoHO,
    HP: logoHP, HQ: logoHQ, HR: logoHR, HS: logoHS, HT: logoHT, HU: logoHU, HV: logoHV, HW: logoHW, HX: logoHX,
    HY: logoHY, HZ: logoHZ, I1: logoI1, I2: logoI2, I3: logoI3, I4: logoI4, I5: logoI5, I6: logoI6, I7: logoI7,
    I8: logoI8, I9: logoI9, IA: logoIA, IB: logoIB, IC: logoIC, ID: logoID, IE: logoIE, IF: logoIF, IG: logoIG,
    IH: logoIH, II: logoII, IJ: logoIJ, IK: logoIK, IL: logoIL, IM: logoIM, IN: logoIN, IO: logoIO, IP: logoIP,
    IQ: logoIQ, IR: logoIR, IS: logoIS, IT: logoIT, IU: logoIU, IV: logoIV, IW: logoIW, IX: logoIX, IY: logoIY,
    IZ: logoIZ, J0: logoJ0, J1: logoJ1, J2: logoJ2, J3: logoJ3, J4: logoJ4, J5: logoJ5, J6: logoJ6, J7: logoJ7,
    J8: logoJ8, J9: logoJ9, JA: logoJA, JB: logoJB, JC: logoJC, JD: logoJD, JE: logoJE, JF: logoJF, JG: logoJG,
    JH: logoJH, JI: logoJI, JJ: logoJJ, JK: logoJK, JL: logoJL, JM: logoJM, JN: logoJN, JO: logoJO, JP: logoJP,
    JQ: logoJQ, JR: logoJR, JS: logoJS, JT: logoJT, JU: logoJU, JV: logoJV, JW: logoJW, JX: logoJX, JY: logoJY,
    JZ: logoJZ, K1: logoK1, K2: logoK2, K3: logoK3, K4: logoK4, K5: logoK5, K6: logoK6, K7: logoK7, K8: logoK8,
    K9: logoK9, KA: logoKA, KB: logoKB, KC: logoKC, KD: logoKD, KE: logoKE, KF: logoKF, KG: logoKG, KH: logoKH,
    KI: logoKI, KJ: logoKJ, KK: logoKK, KL: logoKL, KM: logoKM, KN: logoKN, KO: logoKO, KP: logoKP, KQ: logoKQ,
    KR: logoKR, KS: logoKS, KT: logoKT, KU: logoKU, KV: logoKV, KW: logoKW, KX: logoKX, KY: logoKY, KZ: logoKZ,
    L2: logoL2, L3: logoL3, L4: logoL4, L5: logoL5, L6: logoL6, L7: logoL7, L8: logoL8, L9: logoL9, LA: logoLA,
    LB: logoLB, LC: logoLC, LD: logoLD, LE: logoLE, LF: logoLF, LG: logoLG, LH: logoLH, LI: logoLI, LJ: logoLJ,
    LK: logoLK, LL: logoLL, LM: logoLM, LN: logoLN, LO: logoLO, LP: logoLP, LQ: logoLQ, LR: logoLR, LS: logoLS,
    LT: logoLT, LU: logoLU, LV: logoLV, LW: logoLW, LX: logoLX, LY: logoLY, LZ: logoLZ, M0: logoM0, M2: logoM2,
    M3: logoM3, M4: logoM4, M5: logoM5, M6: logoM6, M7: logoM7, M8: logoM8, M9: logoM9, MA: logoMA, MB: logoMB,
    MC: logoMC, MD: logoMD, ME: logoME, MF: logoMF, MG: logoMG, MH: logoMH, MI: logoMI, MJ: logoMJ, MK: logoMK,
    ML: logoML, MM: logoMM, MN: logoMN, MO: logoMO, MP: logoMP, MQ: logoMQ, MR: logoMR, MS: logoMS, MT: logoMT,
    MU: logoMU, MV: logoMV, MW: logoMW, MX: logoMX, MY: logoMY, MZ: logoMZ, N2: logoN2, N3: logoN3, N4: logoN4,
    N5: logoN5, N6: logoN6, N7: logoN7, N8: logoN8, N9: logoN9, NA: logoNA, NB: logoNB, NC: logoNC, NE: logoNE,
    NF: logoNF, NG: logoNG, NH: logoNH, NI: logoNI, NK: logoNK, NL: logoNL, NM: logoNM, NN: logoNN, NO: logoNO,
    NP: logoNP, NQ: logoNQ, NR: logoNR, NS: logoNS, NT: logoNT, NU: logoNU, NV: logoNV, NW: logoNW, NX: logoNX,
    NY: logoNY, NZ: logoNZ, O2: logoO2, O3: logoO3, O4: logoO4, O5: logoO5, O6: logoO6, O7: logoO7, O8: logoO8,
    O9: logoO9, OA: logoOA, OB: logoOB, OC: logoOC, OD: logoOD, OE: logoOE, OF: logoOF, OG: logoOG, OH: logoOH,
    OI: logoOI, OJ: logoOJ, OK: logoOK, OL: logoOL, OM: logoOM, ON: logoON, OO: logoOO, OP: logoOP, OQ: logoOQ,
    OR: logoOR, OS: logoOS, OT: logoOT, OU: logoOU, OV: logoOV, OW: logoOW, OX: logoOX, OY: logoOY, OZ: logoOZ,
    P0: logoP0, P1: logoP1, P2: logoP2, P3: logoP3, P4: logoP4, P5: logoP5, P6: logoP6, P7: logoP7, P8: logoP8,
    P9: logoP9, PA: logoPA, PB: logoPB, PC: logoPC, PD: logoPD, PE: logoPE, PF: logoPF, PG: logoPG, PH: logoPH,
    PI: logoPI, PJ: logoPJ, PK: logoPK, PL: logoPL, PM: logoPM, PN: logoPN, PO: logoPO, PP: logoPP, PQ: logoPQ,
    PR: logoPR, PS: logoPS, PT: logoPT, PU: logoPU, PV: logoPV, PW: logoPW, PX: logoPX, PY: logoPY, PZ: logoPZ,
    Q0: logoQ0, Q2: logoQ2, Q3: logoQ3, Q4: logoQ4, Q5: logoQ5, Q6: logoQ6, Q7: logoQ7, Q8: logoQ8, Q9: logoQ9,
    QA: logoQA, QB: logoQB, QC: logoQC, QD: logoQD, QE: logoQE, QF: logoQF, QG: logoQG, QH: logoQH, QI: logoQI,
    QJ: logoQJ, QK: logoQK, QL: logoQL, QM: logoQM, QN: logoQN, QO: logoQO, QP: logoQP, QQ: logoQQ, QR: logoQR,
    QS: logoQS, QT: logoQT, QU: logoQU, QV: logoQV, QW: logoQW, QX: logoQX, QY: logoQY, QZ: logoQZ, R0: logoR0,
    R1: logoR1, R2: logoR2, R3: logoR3, R4: logoR4, R5: logoR5, R6: logoR6, R7: logoR7, R8: logoR8, R9: logoR9,
    RA: logoRA, RB: logoRB, RC: logoRC, RD: logoRD, RE: logoRE, RF: logoRF, RG: logoRG, RH: logoRH, RI: logoRI,
    RJ: logoRJ, RK: logoRK, RL: logoRL, RN: logoRN, RO: logoRO, RP: logoRP, RQ: logoRQ, RR: logoRR, RS: logoRS,
    RT: logoRT, RU: logoRU, RV: logoRV, RX: logoRX, RY: logoRY, RZ: logoRZ, S0: logoS0, S1: logoS1, S2: logoS2,
    S3: logoS3, S4: logoS4, S5: logoS5, S6: logoS6, S7: logoS7, S8: logoS8, S9: logoS9, SA: logoSA, SB: logoSB,
    SC: logoSC, SD: logoSD, SE: logoSE, SF: logoSF, SG: logoSG, SH: logoSH, SI: logoSI, SJ: logoSJ, SK: logoSK,
    SL: logoSL, SM: logoSM, SN: logoSN, SO: logoSO, SP: logoSP, SQ: logoSQ, SR: logoSR, SS: logoSS, ST: logoST,
    SU: logoSU, SV: logoSV, SW: logoSW, SX: logoSX, SY: logoSY, SZ: logoSZ, T0: logoT0, T1: logoT1, T2: logoT2,
    T3: logoT3, T4: logoT4, T5: logoT5, T6: logoT6, T7: logoT7, T8: logoT8, TA: logoTA, TB: logoTB, TC: logoTC,
    TD: logoTD, TE: logoTE, TF: logoTF, TG: logoTG, TH: logoTH, TI: logoTI, TJ: logoTJ, TK: logoTK, TL: logoTL,
    TM: logoTM, TN: logoTN, TO: logoTO, TP: logoTP, TQ: logoTQ, TR: logoTR, TS: logoTS, TT: logoTT, TU: logoTU,
    TV: logoTV, TW: logoTW, TX: logoTX, TY: logoTY, TZ: logoTZ, U0: logoU0, U2: logoU2, U3: logoU3, U4: logoU4,
    U5: logoU5, U6: logoU6, U7: logoU7, U8: logoU8, U9: logoU9, UA: logoUA, UB: logoUB, UC: logoUC, UD: logoUD,
    UE: logoUE, UF: logoUF, UG: logoUG, UH: logoUH, UI: logoUI, UJ: logoUJ, UK: logoUK, UL: logoUL, UM: logoUM,
    UN: logoUN, UO: logoUO, UP: logoUP, UQ: logoUQ, UR: logoUR, US: logoUS, UT: logoUT, UU: logoUU, UV: logoUV,
    UW: logoUW, UX: logoUX, UY: logoUY, UZ: logoUZ, V0: logoV0, V2: logoV2, V3: logoV3, V4: logoV4, V5: logoV5,
    V6: logoV6, V7: logoV7, V8: logoV8, V9: logoV9, VA: logoVA, VB: logoVB, VC: logoVC, VD: logoVD, VE: logoVE,
    VF: logoVF, VG: logoVG, VH: logoVH, VI: logoVI, VJ: logoVJ, VK: logoVK, VL: logoVL, VM: logoVM, VN: logoVN,
    VO: logoVO, VP: logoVP, VQ: logoVQ, VR: logoVR, VS: logoVS, VT: logoVT, VU: logoVU, VV: logoVV, VW: logoVW,
    VX: logoVX, VY: logoVY, VZ: logoVZ, W2: logoW2, W3: logoW3, W4: logoW4, W5: logoW5, W6: logoW6, W7: logoW7,
    W8: logoW8, W9: logoW9, WA: logoWA, WB: logoWB, WC: logoWC, WD: logoWD, WE: logoWE, WF: logoWF, WG: logoWG,
    WH: logoWH, WI: logoWI, WJ: logoWJ, WK: logoWK, WL: logoWL, WM: logoWM, WN: logoWN, WO: logoWO, WP: logoWP,
    WQ: logoWQ, WR: logoWR, WS: logoWS, WT: logoWT, WU: logoWU, WV: logoWV, WW: logoWW, WX: logoWX, WY: logoWY,
    WZ: logoWZ, X0: logoX0, X1: logoX1, X2: logoX2, X3: logoX3, X4: logoX4, X5: logoX5, X6: logoX6, X7: logoX7,
    X8: logoX8, X9: logoX9, XA: logoXA, XB: logoXB, XC: logoXC, XD: logoXD, XE: logoXE, XF: logoXF, XG: logoXG,
    XH: logoXH, XI: logoXI, XJ: logoXJ, XK: logoXK, XL: logoXL, XM: logoXM, XN: logoXN, XO: logoXO, XP: logoXP,
    XQ: logoXQ, XR: logoXR, XS: logoXS, XT: logoXT, XU: logoXU, XV: logoXV, XW: logoXW, XX: logoXX, XY: logoXY,
    XZ: logoXZ, Y0: logoY0, Y2: logoY2, Y4: logoY4, Y5: logoY5, Y6: logoY6, Y7: logoY7, Y8: logoY8, Y9: logoY9,
    YA: logoYA, YB: logoYB, YC: logoYC, YD: logoYD, YE: logoYE, YF: logoYF, YG: logoYG, YH: logoYH, YI: logoYI,
    YJ: logoYJ, YK: logoYK, YL: logoYL, YM: logoYM, YN: logoYN, YO: logoYO, YP: logoYP, YQ: logoYQ, YR: logoYR,
    YS: logoYS, YT: logoYT, YU: logoYU, YV: logoYV, YW: logoYW, YX: logoYX, YZ: logoYZ, Z1: logoZ1, Z2: logoZ2,
    Z3: logoZ3, Z4: logoZ4, Z5: logoZ5, Z6: logoZ6, Z7: logoZ7, Z8: logoZ8, Z9: logoZ9, ZA: logoZA, ZB: logoZB,
    ZC: logoZC, ZD: logoZD, ZE: logoZE, ZF: logoZF, ZG: logoZG, ZH: logoZH, ZI: logoZI, ZJ: logoZJ, ZK: logoZK,
    ZL: logoZL, ZM: logoZM, ZN: logoZN, ZO: logoZO, ZP: logoZP, ZQ: logoZQ, ZR: logoZR, ZS: logoZS, ZT: logoZT,
    ZU: logoZU, ZV: logoZV, ZW: logoZW, ZX: logoZX, ZY: logoZY,
};



// WEBPACK FOOTER //
// ./src/app/modules/flights/assets/logos-small.js